import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { normalizePhone } from "../lib/phone";
import { register } from "../lib/api";
import PhoneInput from "../components/PhoneInput";
import { useT } from "../i18n";
import { errorMessage } from "../i18n/errors";

// Вход без SMS-кода: по номеру телефона сервер находит существующего участника
// и выдаёт сессию (ник/пол сохраняются). Открытая регистрация — решение маркетинга.
export default function Login() {
  const nav = useNavigate();
  const { t } = useT();
  const [phone, setPhone] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function submit() {
    setError("");
    const p = normalizePhone(phone);
    if (!p) return setError(t("login.errInvalidPhone"));
    setLoading(true);
    try {
      const r = await register(p);
      // Бэк на незнакомый номер отвечает автоником guest_XXXXXX — значит,
      // аккаунта не было. Регистрация только по номеру запрещена: отправляем
      // дозаполнить профиль (ник/пол/дата), телефон уже предзаполнен.
      const nick = r.participant?.nickname || "";
      if (!nick || /^guest_/i.test(nick) || nick === "Гость") {
        nav(`/register?phone=${encodeURIComponent(p)}&from=login`);
        return;
      }
      nav(`/hub?phone=${encodeURIComponent(p)}`);
    } catch (e: any) {
      setError(errorMessage(e, t));
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-dvh flex flex-col px-7 py-8 max-w-md mx-auto">
      <header className="flex items-center gap-3 mb-6">
        <button
          type="button"
          onClick={() => nav("/start")}
          aria-label={t("prizes.back")}
          className="w-9 h-9 rounded-full bg-white/[0.06] flex items-center justify-center active:bg-white/10 transition-colors shrink-0"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M15 6l-6 6 6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
        <div className="flex-1 min-w-0">
          <h1 className="text-2xl font-extrabold tracking-tight">{t("login.title")}</h1>
          <p className="text-muted text-sm mt-1">{t("login.subtitle")}</p>
        </div>
      </header>
      <div className="flex flex-col gap-4">
        <label className="flex flex-col gap-2">
          <span className="text-sm text-white/80">{t("login.phoneLabel")}</span>
          <PhoneInput value={phone} onChange={setPhone} />
        </label>
        {error && <p className="text-sm text-red-400">{error}</p>}
      </div>
      <button
        type="button"
        onClick={submit}
        disabled={loading}
        className="w-full h-14 rounded-[14px] bg-violet-grad text-white font-extrabold text-base active:opacity-90 transition-opacity disabled:opacity-60 mt-6 shadow-violet-btn"
      >
        {loading ? t("login.submitting") : t("login.submit")}
      </button>
    </div>
  );
}
